const EVENTS = {
    AUTHENTICATED: 'authenticated',
};

export default EVENTS;
